import React, { useEffect } from "react";

const Default = () => {
  useEffect(() => {
    document.location = "https://www.faynutrition.com";
  }, []);
  return <div className="Default"></div>;
};
export default Default;
